import {AccessArea} from 'Common/permissions/AccessArea';
import {Role} from 'Common/permissions/Role';
import { ArtistRole as ArtistRoleConfig } from 'Common/config/Role'; 
import {Id} from 'Common/Id';


export class ArtistRole extends Role
{
	constructor(
		private config: ArtistRoleConfig,
	) { 
		super('artistAdmin');
	}

	public id()
	{
		return this.config.artistId;
	}

	public toJson()
	{
		return {
			type: this.name,
			artistId: this.config.artistId
		};
	}

	public topAccess(): AccessArea
	{
		return new AccessArea('artistEditor');
	}

//XXX this is really more like canAccessSite(). The caller should probably distinguish between venue, artist & admin sites
	public canAccessArea(area:AccessArea,siteId:Id)
	{
		return area.name == 'artistEditor' && siteId == '661f5d42e8b9498a3b54f0f3'; //The artist site ID... TODO put somewhere sensible. Maybe lookup on server startup?
	}

//FIXME types are inconsistent here between artists and venues...
	public amManager(artistId: Id)
	{
console.log('ArtistRole  amManager()  artistId:',artistId,'this.id:',this.id(),'returning:',artistId == this.id());		

		//HACK... when merging into contract branch remove the first test
		return artistId == this.id() || artistId.equals?.(artistId);
	}

	//XXX cf putting permittedArtists() from Manager into here... (but is server-side...)
}

